// Lightweight task creation policy shared with object metadata; no layout/schema dependency.
export const SYSTEM_TASK_TYPE_KEYS = [
  'approval',
  'sign_document',
  'collect_signatures',
  'data_conflict',
  'deviation_approval',
] as const;

/** Origin-owned types need a real decision/signature/conflict, even when a caller supplies a source key. */
export const originTaskType = (type: { key: string; system?: boolean }) =>
  type.system === true || (SYSTEM_TASK_TYPE_KEYS as readonly string[]).includes(type.key);
export const canCreateTaskManually = (type: {
  key: string;
  system?: boolean;
  manualCreation?: boolean;
  archived?: boolean;
}) => !type.archived && !originTaskType(type) && type.manualCreation !== false;
